import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import * as firebase from 'firebase';
import { storageRef } from '../../../constants';
import getTipoArchivos from '../../../utils/getTipoArchivos';
import addAdjuntos from '../../../utils/addAdjuntos';
import getListaArchivos from '../../../utils/getListaArchivos'
import editAdjunto from '../../../utils/editAdjunto';
import Autocomplete from 'react-autocomplete';
import doc from '../../../images/DOC.png';
import pdf from '../../../images/PDF.png';
import xls from '../../../images/XLS.png';
import moment from 'moment';
import { fetchColaboradores, clearColaboradores,fetchPermisos, fetchTipoActividad, fetchHistorialFDV } from '../../../actions';
import { connect } from 'react-redux';
import { FadeLoader } from 'react-spinners';
import ErrorUIComponent from '../../../utils/ErrorUIComponent';
import Alert from '../../../components/Alert';
import getPlacas from "../../../utils/getPlacas"; // <90249> ivelasquez 12/03/2021
import addActivity from '../../../utils/addActivity';
import Paginacion from '../../../components/Paginacion';

let arrayArchivos =[];

const inputProps = {
  className: 'form-control awesomplete pillSelct-input',
  name: 'colaborador',
};

const CustomCheckbox = props => (
  <div className='checkbox'>
    <label htmlFor={`checkbox-${props.cod}`} onClick={e => props.selectAndFetchTipoAgrupacion(e, props.cod)}>
      <input type='checkbox' id={`checkbox-${props.cod}`} checked={props.codTiAct === props.cod} />
      <div className='checkbox-skin' />
      {props.name}
    </label>
  </div>
);

const COD_AUTORIZACIONES_EVENTO ="01";
const COD_PROFORMA_EVENTO = "02";
const COD_SOLICITUD_FACTURACION_EVENTO="03";
const COD_ESTADO_FDV_EVENTO ="04";
const COD_DESA_PEDIDO ="05";
const COD_COMENTARIO ="06";
const COD_ADJUNTOS ="07";
const COD_PEDIDOS_EVENTO ="08";
const COD_LAFIT ="09";
const COD_CAMBIO_CLIENTE="10";
const COD_ASIGNACION_PEDIDO="13";
const COD_DESASIGNACION_DEFINITIVA_PEDIDO_EVENTO="17";
const COD_DESASIGNACION_DEFINITIVA_FICHA_EVENTO="18";

const menuStyle = {
  position: 'absolute',
  left: '0',
  top: '100%',
  maxHeight: '350px',
  overflow: 'auto',
  border: '1px solid #cccccc',
  zIndex: '100',
};

class Adjuntos extends Component {

  constructor(props) {
    super(props);
    this.state = {
      adjuntarArchivos: '',
      mostrarTabla: '',
      files: [],
      listTipoArchivo:[],
      stateProgressbar: 0 ,
      listArchivos:[],
      modalOpen:'none',
      adjuntoOpen:'none',
      EliminarOpen:'none',
      muestraLoad:'none',
      objSelect:{},
      listaColaborador:[],
      itemcodUsuResp:'',
      obsDocumento:'',
      // <I 90249> ivelasquez 12/03/2021
      showPlaca: false,
      listPlacas: [],
      // <F 90249> ivelasquez 12/03/2021

      // Para Tipo de Actividad
      comboActividad: '0',
      listaTipoActividad: [],
      // paginacion
      pagina: 1,
      totalRegistros: 0,
      cantidad: 0,
      countPadres:0,
      // Para lista de eventos
      codTiAct: '',
      eventos:[],
      newAnswer: '',
      respuesta: '',
      colaborador: '',
      colaboradores: [],
    };


    this.guardarAttachFile = this.guardarAttachFile.bind(this);
    this.closeAttachFiles = this.closeAttachFiles.bind(this);
    this.loadGetListaArchivo = this.loadGetListaArchivo.bind(this)
  }

  componentDidMount(){

    const promises = [];
    promises.push(this.props.fetchTipoActividad());

    Promise.all(promises).then((result) => {
      console.log('data tipo actividad : ' + result[0].payload.data.listaTipoActividad);
      this.setState({
        listaTipoActividad: result[0].payload.data.listaTipoActividad
      });
    }).catch(error => console.log(error));

    // <I 90249> ivelasquez 12/03/2021
    getPlacas(this.props.fdvID).then(
        r => {
          this.setState({listPlacas: r.data.listaPlacas})
        }
    );
    // <F 90249> ivelasquez 12/03/2021
    getTipoArchivos()
    .then((r) => {
      this.setState({listTipoArchivo: r.data.tablaMaestroLogistica});
    });
    this.loadGetListaArchivo();
  }

  // PARA COMBO ACTIVIDAD
  changeComboActividad = e => {
    console.log('e : ' + [e.target.name]);
    console.log('e : ' + e.target.value)
    this.setState({ [e.target.name]: e.target.value });
    this.setearObservacionAdjuntos(e.target.value);
  }

  setearObservacionAdjuntos(comboActividadID) {
    console.log(comboActividadID);
    let asuntoActividad = '';
    if (comboActividadID != '0') {
      let actividad = this.state.listaTipoActividad.filter(x => x.idMaeActividad == comboActividadID);
      asuntoActividad = 'Actividad ' + actividad[0].descMaeActividad;
    } 
    this.setState({ obsDocumento: asuntoActividad });
  }

  loadGetListaArchivo(){
    this.setState({ muestraLoad:'block' });

    getListaArchivos(this.props.fdvID).then((r)=>{
      if(r.data !== undefined || r.data !== '' || r.data.length >0 ){
        this.setState({listArchivos : r.data.listaArchivos })
        this.setState({ muestraLoad:'none' });
      }else{
        this.setState({listArchivos : []});
      }
    });

  }

  onDrop(files) {
    this.setState({
      files:[...this.state.files,...files],
      mostrarTabla: true,
    });
  }
// I- GARROYO CARTA FRECUENTES
handleClickTarget(){
  //  console.log(this.props.fdvID);
   this.props
      .fetchPermisos(this.props.fdvID)
      .then(result => {
            for (const [i, product] of result.payload.data.permisosFicha.entries()) {
              if(result.payload.data.permisosFicha[i].mensaje=='URL_C_F'){
                window.open(result.payload.data.permisosFicha[i].permisoTag+this.props.fdvID ); 
              }      
            }
        });
  }
    // F- GARROYO CARTA FRECUENTES
  showAttachFiles() {
    this.setState({ adjuntarArchivos: true });
  }

  showTable() {
    this.setState({ mostrarTabla: true });
  }

  closeAttachFiles() {
    this.setState({ adjuntarArchivos: false, mostrarTabla: false,files:[],stateProgressbar:0 ,listaColaborador:[],obsDocumento:''});
  }

  eliminarFile(){
    this.setState({ muestraLoad:'block' });
    let descripcion = this.state.listTipoArchivo.filter((item)=> item.codTipo === this.state.objSelect.codTipoAdj)[0].descripcion;
    console.log('descripcion',descripcion);
    editAdjunto(this.props.fdvID,this.state.objSelect,true,descripcion).then(()=> this.loadGetListaArchivo()).then(()=> this.setState({modalOpen:'none',muestraLoad:'none'}));
  }

  eliminarFileTmp(){
   this.setState({files: this.state.files.filter(x => x !== this.state.objSelect)},()=> this.setState({EliminarOpen:'none'}));
   if(this.state.files.length===1 && this.state.listaColaborador.length === 0){
    this.closeAttachFiles();
   }
  }

  actualizarFile(){
    for(var i=0 ;i<document.querySelectorAll('.error').length ;i++){
        document.querySelectorAll('.error')[i].style.display='none';
    }
    //document.querySelectorAll('.error').forEach(dropdown => dropdown.style.display='none');

    let name = document.getElementsByName('inputNameEdit')[0].value;
    let select =  document.getElementsByName('selectNameEdit')[0].value;

    if(name === undefined  ||  name.trim() === ''    ||  name === null){
      document.getElementsByName('inputValueEdit')[0].style.display='block';
    }else if(select === undefined  ||  select.trim() === 'false'  ||  select === null) {
      document.getElementsByName('selectValueEdit')[0].style.display='block';
    }else{

      this.setState({ muestraLoad:'block' });


      editAdjunto(this.props.fdvID,this.state.objSelect,false,'').then(()=> this.loadGetListaArchivo()).then(()=> this.setState({adjuntoOpen:'none',muestraLoad:'none'}));
    }

  }

  onClickSelection(e,obj,sw){
    console.log(obj);
    this.setState({objSelect:obj});

    if(sw){
    }else{
      this.setState({EliminarOpen:'block'});
    }
  }
  onChangeValue(val, row){ // <90249> ivelasquez 12/03/2021
    console.log(val);
    console.log(row);
    document.getElementsByName(val)[0].style.display='none';
    // <I 90249> ivelasquez 12/03/2021
    if (row != null)
        if (document.getElementsByName('selectName' + row)[0].value == 13)
            document.getElementById('divPlaca' + row).style.display='block';
        else
            document.getElementById('divPlaca' + row).style.display='none';
    // <F 90249> ivelasquez 12/03/2021
  }
  onChangeValueEdit(val,e){
    const a = this.state.objSelect; // creates the clone of the state
    if(e.target.name === 'selectNameEdit'){
      document.getElementsByName('selectValueEdit')[0].style.display='none';
      a['codTipoAdj'] = e.target.value;
    }
    if(e.target.name === 'inputNameEdit'){
      document.getElementsByName('inputValueEdit')[0].style.display='none';
      a['nomAdj'] = e.target.value;
    }
     this.setState({ objSelect: a });
  }

  getValueDescripcion(val){
    if(this.state.listTipoArchivo.filter( Obj => Obj.codTipo === val).length>0){
      return  this.state.listTipoArchivo.filter( Obj => Obj.codTipo === val)[0].descripcion;
    }else{
      return   'false';
    }
  }



  validateFunction(){
    //console.log('document.querySelectorAll',document.querySelectorAll('.error'));
    //document.querySelectorAll('.error').forEach(dropdown => dropdown.style.display='none');

    for(var i=0;i<document.querySelectorAll('.error').length;i++){
      console.log('querySelectorAll',document.querySelectorAll('.error')[i]);
      document.querySelectorAll('.error')[i].style.display='none';
    }



    let validaInput=0;
    arrayArchivos =[];

    this.state.files.forEach((f,i)=>{

      let objFile={};


      let nameTag = `inputName${i}`;
      let selectTag = `selectName${i}`;
      let selectPlacaTag = `selectPlacaName${i}`; // <90249> ivelasquez 12/03/2021
      let name = document.getElementsByName(nameTag)[0].value;
      let select =  document.getElementsByName(selectTag)[0].value;
      let selectPlaca =  document.getElementsByName(selectPlacaTag)[0].value; // <90249> ivelasquez 12/03/2021
      if( name === undefined  ||  name.trim() === ''    ||  name === null
         ){
          let nameTagVal = `inputValue${i}`;
          document.getElementsByName(nameTagVal)[0].style.display='block';
          validaInput =validaInput +1;
       }else{
        objFile.nameTagVal = name;
       }

      if(select === undefined  ||  select.trim() === 'false'  ||  select === null){
        let selectTagVal = `selectValue${i}`;
        document.getElementsByName(selectTagVal)[0].style.display='block';
        validaInput =validaInput +1;
      }else{
        objFile.selectTagVal = select;
      }
        // <I 90249> ivelasquez 12/03/2021
        if (select == 13)
            if((selectPlaca === undefined  ||  selectPlaca.trim() === 'false'  ||  selectPlaca === null)){
                let selectTagVal = `selectPlacaValue${i}`;
                document.getElementsByName(selectTagVal)[0].style.display='block';
                validaInput =validaInput +1;
            }else{
                objFile.selectPlacaVal = selectPlaca;
            }
        // <F 90249> ivelasquez 12/03/2021
        objFile.file = f;
        if(this.state.listTipoArchivo.filter((item)=> item.codTipo === objFile.selectTagVal).length>0){
          objFile.labelTipo = this.state.listTipoArchivo.filter((item)=> item.codTipo === objFile.selectTagVal)[0].descripcion;
        }
        arrayArchivos.push(objFile);

    });

    console.log(arrayArchivos);
    return validaInput;
}


getExtencion(name){
  let aTipo='';
  let txtsub = name.substring(0,name.indexOf('?'));
  let extencion = txtsub.substring(txtsub.lastIndexOf('.'),txtsub.length);

  switch(extencion){
    case '.pdf':aTipo = pdf;
    break;
    case '.doc':aTipo = doc;
    break;
    case '.docx':aTipo = doc;
    break;
    case '.xls':aTipo = xls;
    break;
    case '.xlsx':aTipo = xls;
    break;
    default:
        aTipo = name;
  }
   return aTipo;
  }

  guardarEventoActividad() {
    const { fdvID } = this.props;
    const { comboActividad, obsDocumento } = this.state;

    console.log('comboActividad : ' + comboActividad);

    if (comboActividad !== '0') {
      console.log('comboActividad Paso: ' + comboActividad);
      let actividad = this.state.listaTipoActividad.filter(x => x.idMaeActividad == comboActividad);
      let asuntoActividad = 'Actividad ' + actividad[0].descMaeActividad;
      let idProceso = '2';
      console.log('Nro Ficha venta : ' + fdvID);
      console.log(asuntoActividad.trim());
      console.log(this.state.listaColaborador);
      
      if (asuntoActividad.trim()) {
        addActivity(fdvID, idProceso, comboActividad, asuntoActividad, obsDocumento,'','00',this.state.listaColaborador.map((item) =>  item.id))
        .then(({ data }) => {
          console.log(data);
          const promises = [];
          promises.push(this.props.fetchHistorialFDV(this.props.fdvID));

          Promise.all(promises).then((result) => {
            console.log('data EVENTO : ' + result[0].payload.data.eventoResponse);
            this.setState({
              eventos:result[0].payload.data.eventoResponse,
              totalRegistros:result[0].payload.data.cantidad,
              countPadres:result[0].payload.data.eventoResponse.length>10?result[0].payload.data.eventoResponse.length-10:0,
              cantidad:10
            });
          }).catch(error => console.log(error));
        });
      }

    }

  }


  guardarAttachFile() {
    
    const { comboActividad } = this.state;
    var fecha = new Date();

    Promise.all([this.validateFunction()])
    .then((results) => {
    if(results[0]=== 0){
      this.setState({muestraLoad:'block'});

        var ref = this;
        console.log(ref);
        return Promise.all(arrayArchivos.map(function(entity) {
          const objFile={};
          objFile.fdvID =  ref.props.fdvID;
          objFile.tipo = entity.selectTagVal;
          objFile.nombre = entity.nameTagVal;
          objFile.labelTipo = entity.labelTipo;
          objFile.placa = entity.selectPlacaVal; // <90249> ivelasquez 12/03/2021

          const archivo = `/images/${fecha.getFullYear()}/${(fecha.getMonth() +1)}/${fecha.getDate()}/${ref.props.fdvID}/${ moment().format('HHmmssSSS') +entity.file.name}`;

          var uploadTask = storageRef.child(archivo).put(entity.file);
          uploadTask.on('state_changed', function(snapshot){
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + progress + '% done');
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused');
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log('Upload is running');
                break;
              default:
                console.log('default');
            }
          }, function(error) {
            console.log('Error uploaded file' + error);
          }, function() {
            objFile.url = uploadTask.snapshot.downloadURL;
            addAdjuntos(
                comboActividad!=='0'?'S':'N',
                objFile,
                ref.state.listaColaborador,
                ref.state.obsDocumento
            ).then((response) => {
              console.log(response);
            });
          });
          return uploadTask;
        })).then((result)=>{

          this.loadGetListaArchivo();

          if(result.length === arrayArchivos.length){
            if (comboActividad !== '0') {
              this.guardarEventoActividad();
            }
            this.closeAttachFiles();
            this.setState({muestraLoad:'none'});
            this.loadGetListaArchivo();
          }
        });

    }
    });

}

  onChangeValueObs = e =>{
    this.setState({ obsDocumento :e.target.value});
  }

  onChangeFunc = (val) => {
    console.log("Valor seleccionado: ", val)
  }

  renderFilesInput() {
    return (
      <tbody>
        {
          this.state.files.map((f,i) =>
            <tr>
              <td>
                <div className='select'>
                  <select className='form-control'
                          name={`selectName${i}`}
                          onChange={()=>this.onChangeValue(`selectValue${i}`, `${i}`)} // <90249> ivelasquez 12/03/2021
                  >
                    <option value='false' disabled='' selected=''>Tipo de archivo</option>
                      {
                        this.state.listTipoArchivo.map(element => (
                          <option value={element.codTipo} key={element.codTipo}>
                          {element.descripcion}
                      </option>
                        ))
                      }
                  </select>
                  <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                </div>
                <span className='error' name={`selectValue${i}`} style={{ display:  'none' }}>Introduce un tipo de archivo</span>

              </td>
              <td>
                <input className='form-control'
                       name={`inputName${i}`}
                       placeholder='Ingresa el nombre o el número'
                       onChange={()=>this.onChangeValue(`inputValue${i}`, null)} // <90249> ivelasquez 12/03/2021
                />
                <span className='error'  name={`inputValue${i}`}  style={{ display: 'none' }}>Introduce un nombre o el número</span>

              </td>
                {/* <I 90249> ivelasquez 12/03/2021 */}
                <td>
                    <div className='select' id={`divPlaca${i}`} style={{display: "none"}}>
                        <select className='form-control' name={`selectPlacaName${i}`} onChange={()=>this.onChangeValue(`selectPlacaValue${i}`, null)} >
                            <option value='false' disabled='' selected=''>[SELECCIONE]</option>
                            {
                                this.state.listPlacas.map(element => (
                                    <option value={element.numPedidoVeh} key={element.numPedidoVeh}>
                                        {element.numPlacaVeh}
                                    </option>
                                ))
                            }
                        </select>
                        <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                    </div>
                    <span className='error' name={`selectPlacaValue${i}`} style={{ display:  'none' }}>Selecciona una placa</span>

                </td>
                {/* <F 90249> ivelasquez 12/03/2021 */}
              <td><span className='btn-iconLeft'><i className='ion-paperclip h6 c-cyan' />{f.name}</span></td>

              <td>
                <button className='btn-clean' onClick={(e)=>this.onClickSelection(e,f,false)}><i className='ion-trash-a h6 c-cyan' /></button>
              </td>
            </tr>
          )
        }
      </tbody>
    );
  }


  render() {
    return (
      <div>
        <ErrorUIComponent>
        <section className='fdv-section' id='adjuntos'>
          <header className='fdv-section-head'>
            <h5 className='fdv-section-title'>Imágenes y documentos</h5>
            <div className='fdv-section-actions'>
            <button target="_blank" className='btn btn-primary btn-sm' 
               onClick={(e) => this.handleClickTarget()}>Carta Frecuente</button>
              &nbsp; &nbsp; &nbsp;
              <button className='btn btn-primary btn-sm' onClick={(e) => this.props.handlePermissions(e) && this.showAttachFiles()} data-permisos='ind_adjuntar_archivos'>Adjuntar archivos</button>
            </div>
          </header>
          {this.state.adjuntarArchivos ? (<div className='attach card card-lg card-plain'>
            <Dropzone
              className='attach-box'
              onDrop={this.onDrop.bind(this)}
              multiple
            >
              <label className='h7' htmlFor='attach1'>
                  Arrastra tus archivos aquí o<span className='btn-link' > seleccionalos de tu computador</span>
              </label>
            </Dropzone>


            <div className={`attach-files ${this.state.mostrarTabla ? 'js-open' : 'js-hide'}`}>

              <div className='tableWrapper'>
                <table className='table table-hover'>
                  <thead className='table-head'>
                    <tr>
                      <th>Tipo</th>
                      <th>Nombre o número</th>
                      <th>Placa</th> {/* <I 90249> ivelasquez 12/03/2021 */}
                      <th>Adjunto</th>
                      <th />
                    </tr>
                  </thead>
                  {
                     this.renderFilesInput()
                  }
                </table>
              </div>

              <div className='form-group'>
                <label htmlFor='subject' className='labelInfo'>Actividad</label>
                <div className="select">
                  <select className='form-control' id='comboActividad' name='comboActividad'
                    value={this.state.comboActividad} onChange={this.changeComboActividad} >
                    <option value='0'>Seleccionar Actividad</option>
                    {
                      this.state.listaTipoActividad.map(actividad => (
                        <option key={actividad.idMaeActividad} value={actividad.idMaeActividad}>
                          {actividad.descMaeActividad}
                        </option>
                      ))
                    }
                  </select>
                  <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                </div>
                  
              </div>

              <div className='form-group'>
                <label className='labelInfo' htmlFor='obsDocumento'>Observaciones</label>
                <textarea className='form-control' placeholder='Ingresa tus observaciones aquí' name='obsDocumento' id='obsDocumento' value={this.state.obsDocumento} onChange={this.onChangeValueObs} maxLength='300' />
              </div>

              <div className='pillSelct'>
                <p className='labelInfo'>Notifica a un colaborador</p>
                <div className='pillSelct-field'>
                  <Autocomplete
                      getItemValue={item => item.idUsuario.toString()}
                      items={this.props.colaboradores}
                      renderItem={(item, isHighlighted) =>
                          <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                            {`${item.apellidos} ${item.nombre}`}
                          </div>
                      }
                      onChange={(e) => {
                        if (e.target.value.length >= 2) {
                          this.props.fetchColaboradores(e.target.value);
                        }
                        if (e.target.value.length === 0) {
                          this.props.clearColaboradores();
                        }
                        this.setState({ itemcodUsuResp: e.target.value });
                      }}
                      value={this.state.itemcodUsuResp}
                      autoHighlight={this.state.trueComplete}
                      onSelect={(key) => {
                        const name = this.props.colaboradores
                            .filter(({ idUsuario }) =>
                                idUsuario.toString() === key)[0].nombre;

                        const apellidos = this.props.colaboradores
                            .filter(({ idUsuario }) =>
                                idUsuario.toString() === key)[0].apellidos;
                        const varpersona = { id: key, apellido: `${apellidos} ${name}` };

                        if (!(this.state.listaColaborador.indexOf(varpersona)>=0)) {
                          this.setState({
                            listaColaborador: [...this.state.listaColaborador,varpersona],
                            itemcodUsuResp: '',
                          });
                        }
                        this.props.clearColaboradores();
                      }}


                      menuStyle={{
                        position: 'absolute',
                        left: '0',
                        top: '100%',
                        maxHeight: '350px',
                        overflow: 'auto',
                        border: '1px solid #cccccc',
                      }}
                      inputProps={{
                        className: 'form-control awesomplete pillSelct-input',
                      }}
                      wrapperStyle={{
                        position: 'relative',
                        zIndex: '10',
                      }}
                  />
                </div>
                <div className='pillSelct-pills'>
                  {
                    this.state.listaColaborador.map(Rows => (
                        <label className='pill pill-cyan pillSelct-pills-item'>{Rows.apellido}
                          <button
                              className='pillSelct-delete'
                              onClick={() => {
                                this.setState({
                                  listaColaborador: this.state.listaColaborador.filter(x => x !== Rows),
                                });
                              }}
                          ><i className='icon ion-close pill-close' />
                          </button>
                        </label>
                    ))
                  }

                </div>

              </div>


              <div className='btnActions'>
                <button className='btn btn-secondary' onClick={() => this.closeAttachFiles()}>Cancelar</button>
                <button className='btn btn-primary' onClick={() => this.guardarAttachFile()}>Guardar</button>
              </div>
            </div>
          </div>) : (null)}
          <div className='row mt-2 mb-4'>
                    {
                      this.state.listArchivos !== undefined ?(
                        this.state.listArchivos.map( f => (

                          <div className='col-md-3 col-sm-4 col-xs-12 mb-2'>
                          <div className='card card-imgTile'>
                            <a data-target='#detalleImageModal'>
                              <div className='card-imageContainer'><img alt='adjunto' className='card-image' src={this.getExtencion(f.txtRutaFire)} />
                              </div>
                            </a>
                            <h4 className='card-title'>{this.getValueDescripcion(f.codTipoAdj)}</h4>
                            <p className='card-text'>{f.nomAdj}</p>
                            <p className='card-text'>{f.dataUsuarop}</p>
                            <p className='card-text'>{ moment(f.fechaCreacion).format('DD/MM/YYYY - HH:mm')}</p>
                            <div className='dropdown kebab card-imgTitle-kebab customToggle' role='group' onClick={(e)=> this.onClickSelection(e,f,true)}>
                              <button className='btn dropdown-toggle kebab-btn ' >
                                <i className='ion-android-more-vertical' />
                              </button>
                              <ul className='dropdown-menu dropdown-menu-right '>
                                <li><a data-target='#fdv-editarAdj' onClick={()=> this.setState({adjuntoOpen:'block'})} ><i className='ion-edit mr-2'  />Editar tipo o nombre</a></li>
                                <li><a data-target='#fdv-eliminarAdj' onClick={()=> this.setState({modalOpen:'block'}) }><i className='ion-trash-a mr-2' />Elminar archivo</a></li>
                                <li><a href={f.txtRutaFire} target="_blank" download><i className='ion-android-download mr-2'  />Descargar documento</a></li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        ))
                      ):(<p> No existe registros </p>)

                    }
          </div>

          <div className="modal in" id="fdv-eliminarAdj" role="dialog" data-backdrop="static" style={{display: this.state.modalOpen}}>
              <div className="modal-dialog" role="document">
                    <button className="btn btn-sm btn-blue modal-close" data-dismiss="modal"  onClick={()=> this.setState({modalOpen:'none'})}>Cerrar ventana</button>
                      <div className="modal-content">
                          <div className="modal-body">
                            <h2 className="modal-title">Eliminar archivo</h2>
                                <p className="h6 text-center">¿Está seguro que deseas eliminar este archivo?</p>
                        <div className="modal-actions">
                        <button className="btn btn-default" data-dismiss="modal" onClick={()=> this.setState({modalOpen:'none'})} >Volver</button>
                        <button className="btn btn-primary pull-right" data-dismiss="modal" onClick={()=> this.eliminarFile()}>Eliminar</button>
                    </div>
                  </div>
                </div>
              </div>
          </div>

          <div className="modal in" id="fdv-eliminarTemp" role="dialog" data-backdrop="static" style={{display: this.state.EliminarOpen}}>
              <div className="modal-dialog" role="document">
                    <button className="btn btn-sm btn-blue modal-close" data-dismiss="modal"  onClick={()=> this.setState({EliminarOpen:'none'})}>Cerrar ventana</button>
                      <div className="modal-content">
                          <div className="modal-body">
                            <h2 className="modal-title">Eliminar archivo</h2>
                                <p className="h6 text-center">¿Está seguro que deseas eliminar este archivo?</p>
                        <div className="modal-actions">
                        <button className="btn btn-default" data-dismiss="modal" onClick={()=> this.setState({EliminarOpen:'none'})} >Volver</button>
                        <button className="btn btn-primary pull-right" data-dismiss="modal" onClick={()=> this.eliminarFileTmp()}>Eliminar</button>
                    </div>
                  </div>
                </div>
              </div>
          </div>


          <div className="modal in" id="fdv-editarAdj" role="dialog" data-backdrop="static" style={{display: this.state.adjuntoOpen}}>
              <div className="modal-dialog modal-lg modal-noTitle" role="document">
                          <button className="btn btn-sm btn-blue modal-close" data-dismiss="modal" onClick={()=> this.setState({adjuntoOpen:'none'})} >Cerrar ventana</button>
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className='attach card card-lg card-plain'>
                              <div className='tableWrapper'>
                              <table className='table table-hover'>
                              <tbody>
                                  <tr>
                                      <td>
                                        <div className='select'>
                                                  <select className='form-control' value={this.state.objSelect.codTipoAdj} name={`selectNameEdit`} onChange={(e)=>this.onChangeValueEdit(`selectValueEdit`,e)}>
                                                    <option value='false' >Tipo de archivo</option>
                                                      {
                                                        this.state.listTipoArchivo.map(element => (
                                                          <option value={element.codTipo} key={element.codTipo}>
                                                          {element.descripcion}
                                                      </option>
                                                        ))
                                                      }
                                                  </select>
                                                  <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                                                </div>
                                                <span className='error' name={`selectValueEdit`} style={{ display:  'none' }}>Introduce un tipo de archivo</span>

                                              </td>
                                              <td>
                                                <input className='form-control' name={`inputNameEdit`} placeholder='Ingresa el nombre o el número' value={this.state.objSelect.nomAdj} onChange={(e)=>this.onChangeValueEdit(`inputValueEdit`,e)} />
                                                <span className='error'  name={`inputValueEdit`}  style={{ display: 'none' }}>Introduce un nombre o el número</span>

                                              </td>

                                            </tr>
                                            </tbody>
                                      </table>
                                      </div>
                                      <div className="modal-actions">
                                          <button className="btn btn-default" data-dismiss="modal" onClick={()=> this.setState({adjuntoOpen:'none'})} >Volver</button>
                                          <button className="btn btn-primary pull-right" data-dismiss="modal" onClick={()=> this.actualizarFile()}>Guardar</button>
                                      </div>
                              </div>
                            </div>
                          </div>
              </div>
          </div>




          <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ display: this.state.muestraLoad }} >
            <div className='modal-dialog modal-sm' role='document'>
              <FadeLoader color={'#F8A14A'} loading />
            </div>
          </div>                                           

        </section>
        </ErrorUIComponent>
        {
          this.props.colaboradores && this.props.colaboradores.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar colaboradores</p>
            </Alert> : null
        }

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    colaboradores: state.colaboradores,
  };
}

Adjuntos.defaultProps = {
  colaboradores: [],
};
export default connect(mapStateToProps,
  {
    fetchColaboradores,
    clearColaboradores,
    fetchPermisos,
    fetchTipoActividad,
    fetchHistorialFDV
  })(Adjuntos);



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Adjuntos.js